import { Component } from '@angular/core';

@Component({
    selector: 'app-authentication-layout',
    templateUrl: './authentication-layout.component.html'
})
export class AuthenticationLayoutComponent {
}
